import React from "react";

import icon_team_group from '../../../assets/img/icon-team-group.svg';

export const QuadrantTalent = ({ title, icon, iconInvert, totalAlways, totalNever, quadrantName, onClick }) => {
  return (
    <div key={`i_${title}`} className="mb-2 d-flex align-items-center border rounded-lg p-2" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="d-flex align-items-center text-reset text-decoration-none flex-fill">
        <div className="pr-2">
          <div className={`mb-0 mr-3 p-2 rounded-circle bg-${quadrantName.toLowerCase()}`}>
            <img className={`icon ${quadrantName.toLowerCase() === 'innovative' ? '' : 'icon-inverse'}`} width="24" height="24" src={iconInvert} alt={title} />
          </div>
        </div>
        <div>
          <p className="h6 mb-1 text-truncate text-nowrap">{title}</p>
          <div className="d-flex align-items-center">
            <p className="d-flex mb-0 mr-2">
              <i className="icon mr-1">
                <svg width="10" height="10" className={`mt-n1 text-always`}>
                  <circle cx="5" cy="5" r="5" fill="currentColor" />
                </svg>
              </i>
              <span className="small font-weight-semibold">{totalAlways}</span>
            </p>

            <p className="d-flex mb-0">
              <i className="icon mr-1">
                <svg width="10" height="10" className={`mt-n1 text-never`}>
                  <circle cx="5" cy="5" r="5" fill="currentColor" />
                </svg>
              </i>
              <span className="small font-weight-semibold">{totalNever}</span>
            </p>
          </div>
        </div>

        <div className="d-flex align-items-center ml-auto">
          <span className="font-weight-semibold mb-0">
            {totalAlways + totalNever}
          </span>
          <span className="ico ml-1">
            <img src={icon_team_group} className='icon-team-group' width="20" height="auto" alt={"Group"} />
          </span>
        </div>
      </div>
    </div>
  );
};